import PropTypes from 'prop-types';

import {Box, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import {Component as ContentfulComponent} from '@amblique/contentful/app/components/contentful/component';

/**
 * CarouselItem component
 * Override this component in your package to provide custom implementation.
 *
 * @param {Object} props - Component props
 * @param {Contentful.CarouselItem} props.component - CarouselItem component data
 * @param {boolean} [props.isComplete] - Whether component has all fields
 * @param {boolean} [props.isFetching] - Whether additional data is being fetched
 * @returns {React.ReactElement}
 */
export const CarouselItem = ({component, isComplete = true, isFetching = false, ...props}) => {
  const {appearance, media, text1, text2, text3, text4} = component;

  const styles = useMultiStyleConfig('contentful/carousel-item', {
    component,
    isComplete,
    isFetching,
    variant: appearance,
  });


  return (
    <Box {...styles.root}>
      {appearance === 'CF-011' ? (
        <Box {...styles.textContainer}>
          <Box {...styles.group1}>
            <Text {...styles.text1}>{text1}</Text>
          </Box>
        </Box>
      ) : appearance === 'CF-012.01' ? (
        <Box {...styles.textContainer}>
          <Box {...styles.group1}>
            <Text {...styles.text1}>{text1}</Text>
            <Text {...styles.text2}>{text2}</Text>
          </Box>

          <Box {...styles.group2}>
            <Text {...styles.text3}>{text3}</Text>
            <Text {...styles.text4}>{text4}</Text>
          </Box>
        </Box>
      ) : appearance === 'CF-012.02' ? (
        <>
          <Box {...styles.group1}>
            <Text {...styles.text1}>{text1}</Text>
            <Text {...styles.text2}>{text2}</Text>
          </Box>
        </>
      ) : appearance === 'CF-013' ? (
        <>
          <Box {...styles.group1}>
            <Text {...styles.text1}>{text1}</Text>
            <Text {...styles.text2}>{text2}</Text>
            <Text {...styles.text3}>{text3}</Text>
          </Box>
        </>
      ) : null}

      {media && <ContentfulComponent component={media} {...styles.media} />}
    </Box>
  );
};

CarouselItem.displayName = 'CarouselItem';
CarouselItem.propTypes = {
  component: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isFetching: PropTypes.bool,
};
